import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const SuggestedBlogs = ({ posts = [] }) => (
  <div className="container">
    <h2 className="heading text-center" style={{ marginBottom: '60px' }}>
      From the Powerplay Blog
    </h2>
    <div className="blog-list-inner">
      <div className="flex-row">
        {posts.map((post) => (
          <div key={post.id} className="col col-4">
            <Link to={post.fields.slug} className="single-blog-inner">
              <img
                src={`/img/blog/${post?.frontmatter?.featuredImage}`}
                alt="Blog"
              />
              <h3>{post.frontmatter.title}</h3>
              <p>{post.excerpt}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);

SuggestedBlogs.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        slug: PropTypes.string.isRequired,
      }).isRequired,
      frontmatter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        featuredImage: PropTypes.string.isRequired,
      }).isRequired,
      excerpt: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default SuggestedBlogs;
